<pos-stepper #cdkStepper linear="true" (selectionChange)="enableForms($event)" [selectedIndex]="selectedIndex">
    <cdk-step label="Información General" [stepControl]="generalnformationForm" [optional]="true">
        <pos-general-information-step [generalnformationForm]="generalnformationForm" (requestTypeEmitter)="handleRequestTypeChange($event)"></pos-general-information-step>
      </cdk-step>
      <cdk-step label="Enlace de Aval" *ngIf="showRepresentativeStep()" [stepControl]="bankRepresentativeForm">
        <app-bank-representative-step [bankRepresentativeForm]="bankRepresentativeForm" [isEdit]="isDraft"></app-bank-representative-step>
      </cdk-step>
      <cdk-step label="Datos Personales" [stepControl]="personInformationForm" [optional]="true">
        <app-person-information-step [personInformationForm]="personInformationForm" [onbaseCatalogue]="onbaseCatalogue" [isShortFormActiveForPlan]="isShortFormActiveForPlan()"></app-person-information-step>
      </cdk-step>
      <cdk-step label="Información de Domicilio" [optional]="true"  [stepControl]="personAddressInformationForm">
        <app-person-address-information-step [onbaseCatalogue]="onbaseCatalogue" [personAddressInformationForm]="personAddressInformationForm" [isEdit]="isDraft" [isShortFormActiveForPlan]="isShortFormActiveForPlan()"></app-person-address-information-step>
      </cdk-step>
      <cdk-step label="Información de Trabajo" [optional]="true" [stepControl]="personIncomeInformationForm">
        <app-person-income-information-step [onbaseCatalogue]="onbaseCatalogue" [personIncomeInformationForm]="personIncomeInformationForm" [customer]="customer"[isEdit]="isDraft" [isShortFormActiveForPlan]="isShortFormActiveForPlan()"></app-person-income-information-step>
      </cdk-step>
      <cdk-step label="Información de Referencias" [optional]="true" [stepControl]="personReferencesInformationform">
        <app-person-references-information-step [personReferencesInformationform]="personReferencesInformationform" [isEdit]="isDraft" [onbaseCatalogue]="onbaseCatalogue" [isShortFormActiveForPlan]="isShortFormActiveForPlan()"></app-person-references-information-step>
      </cdk-step>
      <cdk-step label="Observaciones" [stepControl]="observationForm" [optional]="true">
        <pos-observations-step [observationForm]="observationForm" ></pos-observations-step>
      </cdk-step>
      <cdk-step label="Documentos" [stepControl]="documentsForm" [optional]="true">
        <pos-documents-step [documentsForm]="documentsForm"
        (pictureUrlEmitter)="handlePictureTaken($event)"></pos-documents-step>
      </cdk-step>
      <cdk-step *ngIf="canShowBiometryStep()" [stepControl]="biometryForm" label="Validacion Biometrica" [optional]="true">
        <app-biometry-validation-step
        [creditRequestNumber]="request.code"
        [customer]="customer"
        [isForCreditRequest]="true"
        [pictureUrlString]="pictureUrlString" 
        [biometryLog]="biometryLog"
        (createCreditRequestEmit)="handleCreateCreditRequestFromBiometryValidation($event)" (pictureEmitter)="handlePictureTakenFromBiometry($event)"></app-biometry-validation-step>
      </cdk-step>
      <cdk-step label="Vista Previa">
        <app-credit-request-save-step
          [forms]="getMap()"
          [onbaseCatalogue]="onbaseCatalogue"
          (reconfigureForms)="reenableForms()"
          (createRequest)="createRequest($event)"
          [customer]="customer"
          (gotoStep)="goToStep($event)"
          [resetInput]="selectedIndex"
          [listOfBranchesNotValidateBiometry]="listOfBranchesNotValidateBiometry"
          [creditRequestNumber]="request.code"
          [requestType]="requestType"
          [pictureUrlString]="pictureUrlString"
          [documentsForm]="documentsForm"
          [isShortFormActiveForPlan]="isShortFormActiveForPlan()"
           #saveStepComponent></app-credit-request-save-step>
      </cdk-step>
</pos-stepper>
